import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FormLocalDateField,
  FormSelect,
  FormTextField,
  useFormSelector,
  useStaticListSource,
} from '@eas/common-web';
import { Redirect } from '@composite/redirect/redirect';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import { Deadline } from '@models';
import { EvidenceBrowserUrl } from '@enums';

export function Fields() {
  const { esFile } = useFormSelector((data: Deadline) => ({
    esFile: data.document?.esFile,
  }));

  const { deadlineStates } = useContext(StaticDataContext);
  const source = useStaticListSource(deadlineStates ?? []);

  return (
    <>
      <FormTextField
        name="document.esFile.number.value"
        label={
          <FormattedMessage
            id="ES__DEADLINES__ES_FILE_NUMBER__LABEL"
            defaultMessage="Spisová značka"
          />
        }
        after={
          esFile?.id && (
            <Redirect url={EvidenceBrowserUrl.ES_FILES_ALL} id={esFile.id} />
          )
        }
        disabled={true}
      />
      <FormSelect
        name="state"
        label={
          <FormattedMessage
            id="ES__DEADLINES__STATE__LABEL"
            defaultMessage="Stav"
          />
        }
        source={source}
        valueIsId={true}
        disabled={true}
      />
      <FormTextField
        name="daysRemaining"
        label={
          <FormattedMessage
            id="ES__DEADLINES__DAYS_REMAINING__LABEL"
            defaultMessage="Dnů zbývá"
          />
        }
        disabled={true}
      />
      <FormLocalDateField
        name="startingFrom"
        label={
          <FormattedMessage
            id="ES__DEADLINES__STARTING_FROM__LABEL"
            defaultMessage="Počáteční datum"
          />
        }
      />
      <FormLocalDateField
        name="endDate"
        label={
          <FormattedMessage
            id="ES__DEADLINES__END_DATE__LABEL"
            defaultMessage="Konečné datum"
          />
        }
      />
      <FormTextField
        name="duration"
        label={
          <FormattedMessage
            id="ES__DEADLINES__DURATION__LABEL"
            defaultMessage="Počet dnů"
          />
        }
        disabled={true}
      />
      <FormTextField
        name="document.referenceNumber"
        label={
          <FormattedMessage
            id="ES__DEADLINES__REFERENCE_NUMBER__LABEL"
            defaultMessage="Číslo jednací dokumentu"
          />
        }
        disabled={true}
      />
      <FormTextField
        name="description"
        label={
          <FormattedMessage
            id="ES__DEADLINES__DESCRIPTION__LABEL"
            defaultMessage="Popis"
          />
        }
        disabled={true}
      />
      <FormTextField
        name="document.esFile.indexUserRole.label"
        label={
          <FormattedMessage
            id="ES__DEADLINES__INDEX_USER_ROLE__LABEL"
            defaultMessage="Vedoucí rejstříku"
          />
        }
        disabled={true}
      />
    </>
  );
}
